import { render, staticRenderFns } from "./MedicineNew.vue?vue&type=template&id=5e66b0d7&scoped=true&"
import script from "./MedicineNew.vue?vue&type=script&lang=js&"
export * from "./MedicineNew.vue?vue&type=script&lang=js&"
import style0 from "./MedicineNew.vue?vue&type=style&index=0&id=5e66b0d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66b0d7",
  null
  
)

export default component.exports